<script lang="ts">
    import RequestPageEditorPage from '@Pages/Pages/RequestPageEditorPage'
    export default RequestPageEditorPage
</script>

<template>
    <div>
        <FormEditor :viewModel="formEditor" @save-form="handleCreateFormCommand" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h6>
                        <a class="text-dark" v-sanitizedHref="url_RequestPagesPage">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to pages
                        </a>
                    </h6>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Edit request page</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="handleUpdateRequestPageCommand">Save changes</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">

            <div class="form-group">
                <label>Name:</label>
                <input type="text" v-model.trim="rm.Name" class="form-control" />
                <small>Name of the page.</small>
            </div>

            <div class="form-group">
                <label>Logo url:</label>
                <input type="text" v-model.trim="rm.LogoUrl" class="form-control" />
                <small>Enter url of your logo. Logo will be displayed on your project request page. By default - TransparentChoice's logo.</small>
            </div>

            <label>Form:</label>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <select v-model="rm.FormId" class="form-control">
                            <option v-for="f in rm.Forms" :value="f.Id">{{f.Name}}</option>
                        </select>
                        <small>Choose a form that will be used to collect requests.</small>
                    </div>
                </div>
                <div class="col-lg-4 col-lg-4">
                    <button type="button" @click="showFormCreator"  class="btn btn-outline-secondary">New form</button>
                    <a v-if="rm.FormId" target="_blank" class="btn btn-outline-secondary"  
                       :href="url_EditFormPage(rm.FormId)">Edit form</a>
                </div>
            </div>

            <hr style="margin: 1em 0;" />

            <h4>Content:</h4>
            <div>
                <Editor :tools="tools" ref="editor"
                        :content-style="{ height: '490px',}"
                        :default-content="rm.ContentHtml" />
            </div>
        </div>


    </div>
</template>

<style scoped>

</style>


